import type React from 'react'
import type { IconProps } from './types'

const ChartCombinedIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='none'
		stroke='currentColor'
		strokeWidth={2}
		strokeLinecap='round'
		strokeLinejoin='round'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M12 16v5' />
		<path d='M16 14v7' />
		<path d='M20 10v11' />
		<path d='m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15' />
		<path d='M4 18v3' />
		<path d='M8 14v7' />
	</svg>
)

export default ChartCombinedIcon
